(function () {
  if (window.productListSwatchesBound) return;
  window.productListSwatchesBound = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-product-list-swatch]');
    if (!button) return;

    event.preventDefault();

    var list = button.closest('.product-list__swatches');
    var card = button.closest('.product-list__card');
    if (!list || !card) return;

    list.querySelectorAll('.product-list__swatch-item').forEach(function (item) {
      var itemButton = item.querySelector('[data-product-list-swatch]');
      var selected = itemButton === button;
      item.classList.toggle('is-selected', selected);
      if (itemButton) itemButton.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    var src = button.getAttribute('data-image-src');
    if (src) {
      var img = card.querySelector('.product-list__image--primary');
      if (img) {
        var srcset = button.getAttribute('data-image-srcset');
        img.src = src;
        if (srcset) {
          img.srcset = srcset;
        } else {
          img.removeAttribute('srcset');
        }
      }

      var media = card.querySelector('.product-list__media');
      if (media) media.classList.add('product-list__media--variant-image');
    }

    var variantId = button.getAttribute('data-variant-id');
    if (variantId) {
      var opener = card.querySelector('[data-product-url]');
      if (opener) {
        var currentUrl = opener.getAttribute('data-product-url') || '';
        try {
          var parsed = new URL(currentUrl, window.location.origin);
          parsed.searchParams.set('variant', variantId);
          opener.setAttribute('data-product-url', parsed.pathname + parsed.search);
        } catch (error) {
          opener.setAttribute('data-product-url', currentUrl.split('?')[0] + '?variant=' + variantId);
        }
      }
    }
  });
})();
